import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function IssueChart({ issues }) {
  if (!issues || issues.length === 0) return null;

  const counts = issues.reduce((acc, i) => {
    acc[i.issue] = (acc[i.issue] || 0) + 1;
    return acc;
  }, {});

  const data = {
    labels: Object.keys(counts),
    datasets: [
      {
        label: "Issue Count",
        data: Object.values(counts),
        backgroundColor: "rgba(54,162,235,0.6)",
        borderColor: "rgba(54,162,235,1)",
        borderWidth: 1
      }
    ],
  };

  return (
    <div style={{ maxWidth: "600px", marginTop: 25 }}>
      <h3>📊 Issue Count Chart</h3>
      <Bar data={data} />
    </div>
  );
}
